/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectStorageLimitTraitDTO } from './ProjectStorageLimitTraitDTO';
import {
    ProjectStorageLimitTraitDTOFromJSON,
    ProjectStorageLimitTraitDTOFromJSONTyped,
    ProjectStorageLimitTraitDTOToJSON,
} from './ProjectStorageLimitTraitDTO';

/**
 * 
 * @export
 * @interface ProjectTraitsSetDTO
 */
export interface ProjectTraitsSetDTO {
    /**
     * 
     * @type {ProjectStorageLimitTraitDTO}
     * @memberof ProjectTraitsSetDTO
     */
    storageLimit?: ProjectStorageLimitTraitDTO;
}

/**
 * Check if a given object implements the ProjectTraitsSetDTO interface.
 */
export function instanceOfProjectTraitsSetDTO(value: object): value is ProjectTraitsSetDTO {
    return true;
}

export function ProjectTraitsSetDTOFromJSON(json: any): ProjectTraitsSetDTO {
    return ProjectTraitsSetDTOFromJSONTyped(json, false);
}

export function ProjectTraitsSetDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTraitsSetDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'storageLimit': json['storageLimit'] == null ? undefined : ProjectStorageLimitTraitDTOFromJSON(json['storageLimit']),
    };
}

export function ProjectTraitsSetDTOToJSON(value?: ProjectTraitsSetDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'storageLimit': ProjectStorageLimitTraitDTOToJSON(value['storageLimit']),
    };
}

